/**
 * Display label for an estate row from GET /nominee/estates.
 * Prefers server-computed ownerDisplayName; falls back to possessive formatting.
 */
export function formatEstateDisplayName(estate) {
  const fromApi = String(estate?.ownerDisplayName || '').trim();
  if (fromApi) return fromApi;

  const ownerName = String(estate?.ownerName || '').trim();
  if (!ownerName) return 'Shared estate';

  const possessive = /s$/i.test(ownerName) ? `${ownerName}'` : `${ownerName}'s`;
  return `${possessive} Estate`;
}
